export default __webpack_public_path__ + "static/media/404.15723e8d.png";